import { useEffect, useState } from 'react';

/**
 * The element's layout size in pixels, kept current as it resizes; null until
 * there is one to measure. Unzoomed: inside a CSS-zoomed HUD piece these are
 * the piece's own pixels, the units its CSS lengths are in.
 */
export function useElementSize(element: HTMLElement | null): { width: number; height: number } | null {
    const [size, setSize] = useState<{ width: number; height: number } | null>(null);

    useEffect(() => {
        if (element === null) {
            setSize(null);
            return;
        }
        const measure = (): void => {
            const width = element.offsetWidth;
            const height = element.offsetHeight;
            setSize((current) => (current?.width === width && current.height === height ? current : { width, height }));
        };
        measure();
        if (typeof ResizeObserver === 'undefined') {
            window.addEventListener('resize', measure);
            return () => window.removeEventListener('resize', measure);
        }
        const observer = new ResizeObserver(measure);
        observer.observe(element);
        return () => observer.disconnect();
    }, [element]);

    return size;
}
